module.exports = __webpack_public_path__ + "img/product2_007FFF_date.d9f24824.png";